import { BASE_BACKEND_URL, fetchWithAuth } from '../../../auth'
import { useEffect, useRef, useState } from 'react'


const MIN_SEARCH_LENGTH = 3
const SEARCH_DEBOUNCE_MS = 300

const mapSalesmanToOption = (salesman) => ({
  id: salesman?.id || salesman?.salesman_id || salesman?.db_ref,
  db_ref: salesman?.db_ref || '',
  name: salesman?.name || '',
  label: [salesman?.db_ref, salesman?.name].filter(Boolean).join(' - '),
  raw: salesman
})

const normalizeSalesmanResponse = (response) => {
  const rawSalesmen =
    response?.table ||
    response?.salesmen ||
    response?.results ||
    response?.data ||
    []

  return Array.isArray(rawSalesmen) ? rawSalesmen.map(mapSalesmanToOption) : []
}

const useStoreRelationSalesmanSearch = (searchTerm) => {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const abortControllerRef = useRef(null)
  const debounceTimeoutRef = useRef(null)

  useEffect(() => {
    const normalizedTerm = searchTerm.trim()

    clearTimeout(debounceTimeoutRef.current)

    if (normalizedTerm.length < MIN_SEARCH_LENGTH) {
      abortControllerRef.current?.abort()
      setLoading(false)
      setOptions([])
      return undefined
    }

    debounceTimeoutRef.current = setTimeout(async () => {
      abortControllerRef.current?.abort()

      const controller = new AbortController()
      abortControllerRef.current = controller

      try {
        setLoading(true)

        const response = await fetchWithAuth(
          `${BASE_BACKEND_URL}/poc/salesmen/search?search=${encodeURIComponent(normalizedTerm)}`,
          {
            signal: controller.signal
          }
        )

        setOptions(normalizeSalesmanResponse(response))
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('useStoreRelationSalesmanSearch error', error)
          setOptions([])
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false)
        }
      }
    }, SEARCH_DEBOUNCE_MS)

    return () => {
      clearTimeout(debounceTimeoutRef.current)
      abortControllerRef.current?.abort()
    }
  }, [searchTerm])

  return {
    options,
    loading
  }
}

export default useStoreRelationSalesmanSearch
